<compartido-ficha [configuracion]="configFicha">
  <compartido-calendario
    [anotaciones]="anotaciones"
    [refAnotaciones]="refAnotaciones"
  >
  </compartido-calendario>
</compartido-ficha>

<ng-template #refAnotaciones let-datos>
  <p *ngFor="let anotacion of datos" class="anotacion">{{ anotacion.datos.titulo }}</p>
</ng-template>
